import { render, staticRenderFns } from "./consultor-painel.vue?vue&type=template&id=22891824&scoped=true&"
import script from "./consultor-painel.vue?vue&type=script&lang=js&"
export * from "./consultor-painel.vue?vue&type=script&lang=js&"
import style0 from "./consultor-painel.vue?vue&type=style&index=0&id=22891824&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22891824",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22891824')) {
      api.createRecord('22891824', component.options)
    } else {
      api.reload('22891824', component.options)
    }
    module.hot.accept("./consultor-painel.vue?vue&type=template&id=22891824&scoped=true&", function () {
      api.rerender('22891824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/solicitacoes/components/consultor-painel/consultor-painel.vue"
export default component.exports